import { userInfoSync } from 'hub-http/userInfo';
import { NetworkStatus } from '@apollo/client';
import Raven from 'raven-js';
import enviro from 'enviro';
import { SCOPES } from '../constants/scopes';
import { useGetInstallabilityQuery } from '../../__generated__/chirp/com/hubspot/marketplace/installs/rpc/MarketplaceInstallsRpc.hooks';
export const useIsReconnectable = args => {
  var _args$skip, _args$listingId, _data$installability, _data$installability2;
  const skip = (_args$skip = args === null || args === void 0 ? void 0 : args.skip) !== null && _args$skip !== void 0 ? _args$skip : false;
  const listingId = (_args$listingId = args === null || args === void 0 ? void 0 : args.listingId) !== null && _args$listingId !== void 0 ? _args$listingId : 0;
  const {
    data,
    loading,
    networkStatus
  } = useGetInstallabilityQuery({
    variables: {
      listingId,
      published: true
    },
    skip: skip || !listingId,
    onError: err => {
      Raven.captureException(err, {
        extra: {
          listingId
        }
      });
    }
  });

  /**
   * Case: skip check of scopes and installability intentionally
   */
  if (skip) return {
    isReconnectable: true,
    loading
  };
  const portalInstallable = !!(data !== null && data !== void 0 && (_data$installability = data.installability) !== null && _data$installability !== void 0 && _data$installability.portalInstallable);
  const userInstallable = !!(data !== null && data !== void 0 && (_data$installability2 = data.installability) !== null && _data$installability2 !== void 0 && _data$installability2.userInstallable);

  /**
   * Case: installability data has been received successfully
   */
  if (networkStatus === NetworkStatus.ready) {
    return {
      isReconnectable: portalInstallable && userInstallable,
      loading
    };
  }
  let hasScopeAccess = false;
  try {
    const userInfo = userInfoSync();
    const {
      scopes
    } = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.user) || {
      scopes: []
    };
    hasScopeAccess = scopes.includes(SCOPES.INTEGRATIONS_MANAGEMENT_WRITE);
  } catch (err) {
    if (enviro.isQa()) {
      console.error(err);
    }
    Raven.captureException(err, {
      extra: {
        message: 'Error getting user info from `userInfoSync`'
      }
    });
  }

  /**
   * Fallback: bases on `integrations-management-write` scope access
   */
  return {
    isReconnectable: hasScopeAccess,
    loading
  };
};